/**
 * Commercial / Promotion 2-col 카드 한 칸.
 * MusicVideoItemData 확장: category, date 추가. BEM work-showcase-list__* 로 DOM 생성.
 */
import type { MusicVideoItemData } from "@/home/work/MusicVideoItem";

export interface WorkShowcaseItemData extends MusicVideoItemData {
    category: string;
    date: string;
}

export class WorkShowcaseItem {
    static createArticle(item: WorkShowcaseItemData): HTMLElement {
        const article = document.createElement("article");
        article.className = "work-showcase-list__card";

        const a = document.createElement("a");
        a.className = "work-showcase-list__link";
        a.href = item.href;

        const media = document.createElement("div");
        media.className = "work-showcase-list__media";

        if (item.thumb) {
            const img = document.createElement("img");
            img.className = "work-showcase-list__thumb";
            img.src = item.thumb;
            img.alt = item.title;
            img.loading = "lazy";
            img.decoding = "async";
            media.appendChild(img);
        } else {
            const ph = document.createElement("span");
            ph.className = "work-showcase-list__thumb work-showcase-list__thumb--placeholder";
            ph.setAttribute("aria-hidden", "true");
            media.appendChild(ph);
        }

        a.appendChild(media);

        const body = document.createElement("div");
        body.className = "work-showcase-list__body";

        const titleEl = document.createElement("h2");
        titleEl.className = "work-showcase-list__title";
        titleEl.textContent = item.title;
        body.appendChild(titleEl);

        if (item.date) {
            const dateEl = document.createElement("p");
            dateEl.className = "work-showcase-list__date";
            dateEl.textContent = item.date;
            body.appendChild(dateEl);
        }

        a.appendChild(body);
        article.appendChild(a);

        return article;
    }
}
